import { useQuery } from '@tanstack/react-query'

import { DEFAULT_THEME } from '@apps-common/config/theme'
import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { hydrateTheme } from '@apps-common/theme/hydrateTheme'
import type { PortalThemeModel } from '@apps-common/types/portal/theme'

export const QUERY_GET_PORTAL_THEME = (companyId?: string) => ['getPortalTheme', companyId]

export const getPortalTheme = async (companyId?: string): Promise<PortalThemeModel> => {
  const res = await axios.get(`/PortalTheme/GetPortalTheme?companyId=${companyId ?? ''}`)
  const theme = res?.data?.data as PortalThemeModel | undefined

  if (theme) return hydrateTheme(theme)

  return DEFAULT_THEME
}

type QueryFnType = typeof getPortalTheme

type Props = {
  config?: QueryConfig<QueryFnType>
  companyId?: string
}

export const useGetPortalTheme = ({ config, companyId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    gcTime: 0,
    queryKey: QUERY_GET_PORTAL_THEME(companyId),
    queryFn: () => getPortalTheme(companyId)
  })
